export default {"src":"/_next/static/media/business.1c886199.svg","height":16,"width":16};